const getActiveCampaignBanner = (banner, { globalStoreId  })=>{
    if (!banner) {
        return;
    }
    if (!(banner === null || banner === void 0 ? void 0 : banner.startDate) || !(banner === null || banner === void 0 ? void 0 : banner.endDate)) {
        return;
    }
    if (!(Date.now() > banner.startDate && Date.now() < banner.endDate)) {
        return;
    }
    // if there is no store specified we need to show the banner on all stores
    if (!banner.storesList) {
        return {
            url: banner.url,
            description: banner.description
        };
    }
    const list = banner.storesList.split(',').map((item)=>item.replace(/\s/g, '')
    );
    const found = list === null || list === void 0 ? void 0 : list.find((item)=>item === globalStoreId
    );
    if (found !== globalStoreId) {
        return;
    }
    return {
        url: banner.url,
        description: banner.description
    };
};

export { getActiveCampaignBanner };
//# sourceMappingURL=get-active-campaign-banner.js.map
